import type { TFunction } from 'i18next';

type GetDomainsItemsTitleProps = {
  urlsLength: number;
  inventoryListItemsLength: number;
  isBlacklist: boolean;
  isOa: boolean;
  t: TFunction;
};

export const getDomainsItemsTitle = ({
  urlsLength,
  inventoryListItemsLength,
  isBlacklist,
  isOa,
  t,
}: GetDomainsItemsTitleProps) => {
  if (inventoryListItemsLength && isOa) {
    return t('{blacklist} domains [ {count} ]', {
      count: urlsLength,
      blacklist: isBlacklist ? t('blocked') : t('allowed'),
    });
  }

  return t('{blacklist} domains', {
    blacklist: isBlacklist ? t('blocked') : t('allowed'),
  });
};
